import { render, staticRenderFns } from "./LeftImage.vue?vue&type=template&id=b94e79fe&scoped=true"
import script from "./LeftImage.vue?vue&type=script&lang=js"
export * from "./LeftImage.vue?vue&type=script&lang=js"
import style0 from "./LeftImage.vue?vue&type=style&index=0&id=b94e79fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94e79fe",
  null
  
)

export default component.exports